import { connect } from "react-redux";
import { updateModal } from "@/store/app/app.slice";
import { ConnectedProps } from "react-redux";
import { useState } from "react";
import { AlertDialog } from "@/utils/ui/AlertDialog/AlertDialog";
import ProfileIcon from "../../assets/svg/profile.svg?react";

interface UserDetailCardProps {
  img: string;
  name: string;
  phoneNumber: string;
  details: { label: string; value: string; options?: any }[];
}

const UserDetailCard = ({
  img,
  name,
  phoneNumber,
  details,
  updateModal,
}: UserDetailCardProps & ConnectedProps<typeof connector>) => {
  const [isConfirmModalOpen, setConfirmModalOpen] = useState(false);

  const handleLogoutClick = () => {
    setConfirmModalOpen(true);
    updateModal(true);
  };

  const handleCloseModal = () => {
    setConfirmModalOpen(false);
    updateModal(false);
  };

  const handleConfirmLogout = () => {
    const redirectParam = encodeURIComponent(window.location.origin);
    window.location.href = `${
      process.env.NX_APP_LOGOUT_URL || ""
    }?redirect=${redirectParam}`;
  };

  return (
    <>
      <div className="card">
        <div className="card-header d-flex align-items-center justify-content-between">
          <h6>Profile Information</h6>
          <div
            role="button"
            className="btn btn-outline-danger d-flex"
            onClick={handleLogoutClick}
          >
            LOGOUT
          </div>
        </div>
        <div className="row card-body">
          <div className="col-3 d-flex flex-column align-items-center justify-content-center pt-2">
            <ProfileIcon
              className="rounded-circle bi profile"
              style={{ width: "100px", height: "100px", opacity: "0.8" }}
            />
            <h5 className="mt-2">{name}</h5>
            <p className="mt-2">{phoneNumber}</p>
          </div>
          <div className="col-9">
            <div className="ps-3 my-3 row">
              {details.map((detail: any, index: any) => (
                <div key={index} className="mb-3 col-6">
                  <small className="pb-1 d-block fs-6">{detail.label}</small>
                  <span>{detail.value}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      {isConfirmModalOpen && (
        <AlertDialog
          isOpen={isConfirmModalOpen}
          onClose={handleCloseModal}
          onConfirm={handleConfirmLogout}
          title="ALERT!"
          message="Are you sure you want to logout?"
          confirmText="Confirm"
          cancelText="Cancel"
        />
      )}
    </>
  );
};

const mapDispatch = {
  updateModal,
};

const connector = connect(null, mapDispatch);

export default connector(UserDetailCard);
